import React, { FC, useContext } from 'react'

import { Icon } from '@vividseats/vivid-ui-kit'

import Banner from '@/components/pages/production/components/banner'
import PromoBanner from '@/components/pages/production/components/promo-banner'
import PromoContext from '@/context/promo/context'
import UrgencyVelocityContext from '@/context/urgency-velocity/context'
import { FlameIcon } from '@/design-system/custom-icons'

import styles from './styles.module.scss'

interface ProductionListingsBannerProps {
    className?: string
}

const ProductionListingsBanner: FC<ProductionListingsBannerProps> = ({ className }) => {
    const {
        selectors: { promo },
    } = useContext(PromoContext)

    const {
        selectors: { urgencyLongterm, velocityLongterm },
    } = useContext(UrgencyVelocityContext)

    if (!!promo)
        return (
            <div className={className}>
                <PromoBanner promo={promo} />
            </div>
        )

    if (!!velocityLongterm)
        return (
            <div className={className}>
                <Banner type="velocity">
                    <FlameIcon className={styles.paddingRight} />
                    {velocityLongterm} fans recently purchased
                </Banner>
            </div>
        )

    if (!!urgencyLongterm)
        return (
            <div className={className}>
                <Banner type="urgency">
                    <Icon type="eye-filled" className={styles.paddingRight} />
                    {urgencyLongterm} fans shopping for these tickets
                </Banner>
            </div>
        )

    return null
}

export default ProductionListingsBanner
